import client from '@/lib/axios-client'
import type {
	ApiResponse,
	ClassificationWithSubsListOutput,
	KindWithRisksListOutput,
	KindWithRisksOutput,
} from '@/types'

const KIND_URL = '/catalog/kind'
const CLASSIFICATION_URL = '/catalog/classification'

// --- Kind ---

export async function getKindList(): Promise<
	ApiResponse<KindWithRisksListOutput>
> {
	const response = await client.get(KIND_URL)
	return response.data.data
}

export async function createKind(data: {
	name: string
	spheraName?: string | null
	risks: { name: string }[]
}): Promise<KindWithRisksOutput> {
	const response = await client.post(KIND_URL, data)
	return response.data.data
}

export async function updateKind(
	id: string,
	data: {
		name: string
		spheraName?: string | null
		risks: { id?: string; name: string }[]
	},
): Promise<KindWithRisksOutput> {
	const response = await client.put(`${KIND_URL}/${id}`, data)
	return response.data.data
}

export async function deleteKind(id: string): Promise<void> {
	await client.delete(`${KIND_URL}/${id}`)
}

// --- Classification ---

export async function getClassificationList(): Promise<
	ApiResponse<ClassificationWithSubsListOutput>
> {
	const response = await client.get(CLASSIFICATION_URL)
	return response.data.data
}

export async function createClassification(data: {
	name: string
	spheraName?: string | null
	subclassifications: { name: string }[]
}): Promise<ClassificationWithSubsListOutput['items'][0]> {
	const response = await client.post(CLASSIFICATION_URL, data)
	return response.data.data
}

export async function updateClassification(
	id: string,
	data: {
		name: string
		spheraName?: string | null
		subclassifications: { id?: string; name: string }[]
	},
): Promise<ClassificationWithSubsListOutput['items'][0]> {
	const response = await client.put(`${CLASSIFICATION_URL}/${id}`, data)
	return response.data.data
}

export async function deleteClassification(id: string): Promise<void> {
	await client.delete(`${CLASSIFICATION_URL}/${id}`)
}
